module.exports = __webpack_public_path__ + "static/media/course2.37228139.png";